export default __webpack_public_path__ + "static/media/Explorer.256.f4992f59.png";